export const printSpecs = {
  A0: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig'],
    materials: ['75g', '120g'],
    treatments: ['Rollen', 'Vouwen', 'Boren', 'Plastificeren'],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Vouwen: [
      'A4 vouwen',
      '19 cm vouwen',
      '19 cm vouwen+ filestrip',
      '19 cm vouwen + hechtrand',
      '19 cm vouwen + hechtrand + 4 gaten'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'Tyvek 75g + standaard 75g',
      'Backlit Film',
      'Banner',
      'Polyester doek 195g',
      'Fluor geel papier',
      'Wit papier 150g FSC Mat',
      'Wit papier 150g FSC Glans',
      'Tyvek 75g',
      'Permanente sticker',
      'Verwijderbare sticker'
    ]
  },
  A1: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig'],
    materials: ['75g', '120g'],
    treatments: ['Rollen', 'Vouwen', 'Boren', 'Plastificeren'],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Vouwen: [
      'A4 vouwen',
      '19 cm vouwen',
      '19 cm vouwen+ filestrip',
      '19 cm vouwen + hechtrand',
      '19 cm vouwen + hechtrand + 4 gaten'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'Tyvek 75g + standaard 75g',
      'Backlit Film',
      'Banner',
      'Polyester doek 195g',
      'Fluor geel papier',
      'Wit papier 150g FSC Mat',
      'Wit papier 150g FSC Glans',
      'Tyvek 75g',
      'Permanente sticker',
      'Verwijderbare sticker'
    ]
  },
  A2: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig'],
    materials: ['75g', '120g'],
    treatments: ['Rollen', 'Vouwen', 'Boren', 'Plastificeren'],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Vouwen: [
      'A4 vouwen',
      '19 cm vouwen',
      '19 cm vouwen+ filestrip',
      '19 cm vouwen + hechtrand',
      '19 cm vouwen + hechtrand + 4 gaten'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'Tyvek 75g + standaard 75g',
      'Backlit Film',
      'Banner',
      'Polyester doek 195g',
      'Fluor geel papier',
      'Wit papier 150g FSC Mat',
      'Wit papier 150g FSC Glans',
      'Tyvek 75g',
      'Permanente sticker',
      'Verwijderbare sticker'
    ]
  },
  A3: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    Vouwen: ['C-vouw', 'V-vouw', 'Z-vouw'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Permanente sticker',
      'Tyvek 75g',
      'Verwijderbare sticker'
    ]
  },
  A4: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    Vouwen: ['C-vouw', 'V-vouw', 'Z-vouw'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Permanente sticker',
      'Tyvek 75g',
      'Verwijderbare sticker'
    ]
  },
  A5: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Permanente sticker',
      'Tyvek 75g',
      'Verwijderbare sticker'
    ]
  },
  A6: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Permanente sticker',
      'Tyvek 75g',
      'Verwijderbare sticker'
    ]
  },
  'Als bestand': {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['75g', '80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Vouwen: [
      'A4 vouwen',
      '19 cm vouwen',
      '19 cm vouwen+ filestrip',
      '19 cm vouwen + hechtrand',
      '19 cm vouwen + hechtrand + 4 gaten',
      'C-vouw',
      'V-vouw',
      'Z-vouw'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'Tyvek 75g + standaard 75g',
      'Backlit Film',
      'Banner',
      'Polyester doek 195g',
      'Fluor geel papier',
      'Wit papier 150g FSC Mat',
      'Wit papier 150g FSC Glans',
      'Tyvek 75g',
      'Permanente sticker',
      'Verwijderbare sticker'
    ]
  }
}

export const securePrintSpecs = {
  A3: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    Vouwen: ['C-vouw', 'Z-vouw'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Tyvek 75g'
    ]
  },
  A4: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    Vouwen: ['C-vouw', 'Z-vouw'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Tyvek 75g'
    ]
  },
  A5: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Tyvek 75g'
    ]
  },
  A6: {
    colorMode: ['Zwart/Wit', 'Kleur'],
    sideMode: ['Enkelzijdig', 'Dubbelzijdig'],
    materials: ['80g', '100g', '120g', '160g', '200g', '250g', '300g'],
    treatments: [
      'Rollen',
      'Nieten',
      'Vouwen',
      'Ringband',
      'Boren',
      'Plastificeren'
    ],
    Ringband: [
      'Ringband plastic',
      'Ringb plastic, transparant voor, karton achter',
      'Ringb plastic, transparant voor en achter',
      'Ringband metaal',
      'Ringb metaal, transparant voor, karton achter',
      'Ringb metaal, transparant voor en achter'
    ],
    Boren: [
      '2 gats boring',
      '4 gats boring',
      '2 gats boring + snelhechter',
      '2 gats boring + Jalema clip'
    ],
    Plastificeren: ['Plastificeren glans', 'Plastificeren mat'],
    paperType: [
      'MC Gloss 115g',
      'MC Gloss 150g',
      'MC Gloss 200g',
      'MC Gloss 250g',
      'Off-white 80g',
      'Off-white 100g',
      'Off-white 200g',
      'Off-white 300g',
      'Tyvek 75g'
    ]
  }
}

export const printTemplates = {
  Boekje: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A5'],
      default: 'A4',
      align: 'left'
    },
    {
      title: 'Papiersoort',
      type: 'slider',
      options: ['80g', '100g', '120g'],
      default: '100g',
      align: 'right'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'left'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '2 z',
      align: 'right'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'nee'
    },
    {
      title: 'Bindwijze',
      type: 'option',
      options: {
        'Ringband metaal': {
          type: 'submenu',
          submenus: [
            {
              title: 'Voorkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Bedrukt (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            },
            {
              title: 'Achterkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Blanco (zeer stevig)',
                'Bedrukt (zeer stevig)',
                'Transparant + blanco (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant + blanco (zeer stevig)'
            }
          ]
        },
        'Ringband plastic': {
          type: 'submenu',
          submenus: [
            {
              title: 'Voorkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Bedrukt (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            },
            {
              title: 'Achterkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Blanco (zeer stevig)',
                'Bedrukt (zeer stevig)',
                'Transparant + blanco (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            }
          ]
        },
        'Garenloos (lijmen)': {
          type: 'submenu',
          submenus: [
            {
              title: 'Omslag',
              type: 'option',
              options: [
                'Voorkant bedrukt (zeer stevig)',
                'Bedrukt pagina 1+2 (zeer stevig)',
                'Bedrukt voor & achter (zeer stevig)'
              ],
              default: 'Voorkant bedrukt (zeer stevig)'
            }
          ]
        }
      },
      default: 'Ringband metaal'
    }
  ],
  Poster: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A3', 'A2', 'A1', 'A0'],
      default: 'A0'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja',
      align: 'right'
    },
    {
      title: 'Papiersoort',
      type: 'option',
      options: {
        'Wit papier 150g FSC glans': {},
        'Wit papier 150g FSC mat': {}
      },
      default: 'Wit papier 150g FSC mat'
    },
    {
      title: 'Plastificeren',
      type: 'option',
      options: {
        Geen: {},
        Glans: {},
        Mat: {}
      },
      default: 'Geen'
    },
    {
      title: 'Monteren op foambord',
      type: 'option',
      options: {
        Nee: {},
        'Ja op 5 mm': {},
        'Ja op 10 mm': {}
      },
      default: 'Nee'
    }
  ],
  Banner: [
    {
      title: 'Formaat breedte',
      type: 'slider',
      options: ['85cm', '100cm'],
      default: '85cm',
      align: 'left'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'right'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja'
    },
    {
      title: 'Banner systeem',
      type: 'option',
      options: {
        'Roll-up standaard (210cm hoogte)': {},
        'Roll-up deluxe (160 - 215cm hoogte)': {}
      },
      default: 'Roll-up deluxe (160 - 215cm hoogte)'
    }
  ],
  Flyer: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A6', 'A5', 'A4'],
      default: 'A5',
      align: 'left'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'right'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '1 z',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja',
      align: 'right'
    },
    {
      title: 'Papiersoort',
      type: 'option',
      options: {
        '80g papier': {},
        '100g papier': {},
        '120g papier': {},
        '160g papier': {},
        '200g papier': {},
        '250g papier': {},
        '300g papier': {}
      },
      default: '160g papier'
    },
    {
      title: 'Plastificeren',
      type: 'option',
      options: {
        Geen: {},
        Glans: {},
        Mat: {}
      },
      default: 'Geen'
    }
  ],
  Visitekaartje: [
    {
      title: 'Formaat',
      type: 'option',
      options: {
        '85x55mm': {}
      },
      default: '85x55mm',
      align: 'left'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '1 z',
      align: 'right'
    },
    {
      title: 'Aantal',
      type: 'slider',
      options: ['100', '250', '500'],
      default: '100',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja',
      align: 'right'
    },
    {
      title: 'Papiersoort',
      type: 'option',
      options: {
        'Wit 300gr': {},
        'Off-white 300gr': {}
      },
      default: 'Wit 300gr'
    },
    {
      title: 'Plastificeren',
      type: 'option',
      options: {
        Geen: {},
        Glans: {},
        Mat: {}
      },
      default: 'Geen'
    }
  ],
  'Presentatie paneel': [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A3', 'A2', 'A1', 'A0', 'B1', 'B0'],
      default: 'A1'
    },
    {
      title: 'Snijden',
      type: 'option',
      options: {
        'Aflopend snijden': {},
        'Vorm uitsnijden': {},
        'Niet snijden': {}
      },
      default: 'Aflopend snijden'
    },
    {
      title: 'Materiaal',
      type: 'option',
      options: {
        'Honingraatkarton 10 mm FSC': {},
        'Foambord 5 mm': {},
        'Foambord 10 mm': {},
        'Recycled kunststof wit 3mm (Forex)': {},
        'Recycled kunststof wit 5mm (Forex)': {},
        'Aluminium sandwichplaat 3 mm (Dibond)': {},
        'Recycled Acrylaat helder 5 mm': {},
        'Scheurvast kunststof 1,2 mm': {}
      },
      default: 'Honingraatkarton 10 mm FSC'
    }
  ],
  Brochure: [
    {
      title: 'Eindformaat',
      type: 'slider',
      options: ['A4', 'A5'],
      default: 'A5',
      align: 'left'
    },
    {
      title: 'Papiersoort',
      type: 'slider',
      options: ['80g', '100g', '120g'],
      default: '100g',
      align: 'right'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['2 z'],
      default: '2 z',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'nee',
      align: 'right'
    },
    {
      title: 'Z/W of kleur',
      type: 'option',
      options: {
        'Z/W': {},
        Kleur: {},
        'Alleen omslag kleur': {}
      },
      default: 'Kleur'
    },
    {
      title: 'Bindwijze',
      type: 'option',
      options: {
        'Vouwen & nieten': {
          type: 'submenu',
          submenus: [
            {
              title: 'Omslag',
              type: 'option',
              options: [
                'Bedrukt alleen voorpagina',
                'Bedrukt pagina 1+2',
                'Bedrukt voor & achter'
              ],
              default: 'Bedrukt voor & achter'
            },
            {
              title: 'Papiersoort omslag',
              type: 'option',
              options: [
                'Gelijk aan boekje',
                'Stevig 120g',
                'Extra stevig 160g'
              ],
              default: 'Extra stevig 160g'
            }
          ]
        }
      },
      default: 'Vouwen & nieten'
    }
  ],
  Rapport: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A5'],
      default: 'A4',
      align: 'left'
    },
    {
      title: 'Papiersoort',
      type: 'slider',
      options: ['80g', '100g', '120g'],
      default: '100g',
      align: 'right'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'left'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '2 z',
      align: 'right'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'nee'
    },
    {
      title: 'Bindwijze',
      type: 'option',
      options: {
        'Ringband metaal': {
          type: 'submenu',
          submenus: [
            {
              title: 'Voorkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Bedrukt (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            },
            {
              title: 'Achterkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Blanco (zeer stevig)',
                'Bedrukt (zeer stevig)',
                'Transparant + blanco (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant + blanco (zeer stevig)'
            }
          ]
        },
        'Ringband plastic': {
          type: 'submenu',
          submenus: [
            {
              title: 'Voorkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Bedrukt (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            },
            {
              title: 'Achterkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Blanco (zeer stevig)',
                'Bedrukt (zeer stevig)',
                'Transparant + blanco (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            }
          ]
        },
        'Garenloos (lijmen)': {
          type: 'submenu',
          submenus: [
            {
              title: 'Omslag',
              type: 'option',
              options: [
                'Voorkant bedrukt (zeer stevig)',
                'Bedrukt pagina 1+2 (zeer stevig)',
                'Bedrukt voor & achter (zeer stevig)'
              ],
              default: 'Voorkant bedrukt (zeer stevig)'
            }
          ]
        }
      },
      default: 'Garenloos (lijmen)'
    }
  ]
}

export const securePrintTemplates = {
  Poster: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A3', 'A2', 'A1', 'A0'],
      default: 'A0'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja',
      align: 'right'
    },
    {
      title: 'Papiersoort',
      type: 'option',
      options: {
        'Matt 180g': {}
      },
      default: 'Matt 180g'
    },
    {
      title: 'Plastificeren',
      type: 'option',
      options: {
        Geen: {},
        Glans: {},
        Mat: {},
        'Glans beide kanten': {},
        'Mat beide kanten': {},
        'Glans voor mat achter': {}
      },
      default: 'Geen'
    },
    {
      title: 'Monteren op foambord',
      type: 'option',
      options: {
        Nee: {},
        'Ja op 5 mm': {},
        'Ja op 10 mm': {}
      },
      default: 'Nee'
    }
  ],
  Banner: [
    {
      title: 'Formaat breedte',
      type: 'slider',
      options: ['85cm', '100cm'],
      default: '85cm',
      align: 'left'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'right'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja'
    },
    {
      title: 'Banner systeem',
      type: 'option',
      options: {
        'Roll-up standaard (210cm hoogte)': {},
        'Roll-up deluxe (160 - 215cm hoogte)': {}
      },
      default: 'Roll-up deluxe (160 - 215cm hoogte)'
    },
    {
      title: 'Stuur mij de aanleverspecificaties per email',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja'
    }
  ],
  Flyer: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A6', 'A5', 'A4'],
      default: 'A5',
      align: 'left'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'right'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '1 z',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja',
      align: 'right'
    },
    {
      title: 'Papiersoort',
      type: 'option',
      options: {
        '80g papier': {},
        '100g papier': {},
        '120g papier': {},
        '160g papier': {},
        '200g papier': {},
        '250g papier': {},
        '300g papier': {}
      },
      default: '160g papier'
    },
    {
      title: 'Plastificeren',
      type: 'option',
      options: {
        Geen: {},
        Glans: {},
        Mat: {},
        'Glans beide kanten': {},
        'Mat beide kanten': {},
        'Glans voor mat achter': {}
      },
      default: 'Geen'
    }
  ],
  Visitekaartje: [
    {
      title: 'Formaat',
      type: 'option',
      options: {
        '85x55mm': {}
      },
      default: '85x55mm',
      align: 'left'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '1 z',
      align: 'right'
    },
    {
      title: 'Aantal',
      type: 'slider',
      options: ['100', '250', '500'],
      default: '100',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'ja',
      align: 'right'
    },
    {
      title: 'Papiersoort',
      type: 'option',
      options: {
        '300g wit': {},
        '270g gebroken wit': {}
      },
      default: '300g wit'
    },
    {
      title: 'Plastificeren',
      type: 'option',
      options: {
        Geen: {},
        Glans: {},
        Mat: {}
      },
      default: 'Geen'
    }
  ],
  'Presentatie paneel': [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A3', 'A2', 'A1', 'A0', 'B1', 'B0'],
      default: 'A1'
    },
    {
      title: 'Snijden',
      type: 'option',
      options: {
        'Aflopend snijden': {},
        'Vorm uitsnijden': {},
        'Niet snijden': {}
      },
      default: 'Aflopend snijden'
    },
    {
      title: 'Materiaal',
      type: 'option',
      options: {
        'Honingraat karton 10 mm': {},
        'Foambord 5 mm': {},
        'Foambord 10 mm': {},
        'Forex 3 mm': {},
        'Forex 5 mm': {},
        'Dibond 3 mm': {},
        'Reboard 10 mm': {},
        'Reboard 16 mm': {},
        'Acrylaat 5 mm': {},
        'Polypropyleen 1,2 mm': {}
      },
      default: 'Honingraat karton 10 mm'
    }
  ],
  Brochure: [
    {
      title: 'Eindformaat',
      type: 'slider',
      options: ['A4', 'A5'],
      default: 'A5',
      align: 'left'
    },
    {
      title: 'Papiersoort',
      type: 'slider',
      options: ['80g', '100g', '120g'],
      default: '100g',
      align: 'right'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['2 z'],
      default: '2 z',
      align: 'left'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'nee',
      align: 'right'
    },
    {
      title: 'Z/W of kleur',
      type: 'option',
      options: {
        'Z/W': {},
        Kleur: {},
        'Alleen omslag kleur': {}
      },
      default: 'Kleur'
    },
    {
      title: 'Bindwijze',
      type: 'option',
      options: {
        'Vouwen & nieten': {
          type: 'submenu',
          submenus: [
            {
              title: 'Omslag',
              type: 'option',
              options: [
                'Bedrukt alleen voorpagina',
                'Bedrukt pagina 1+2',
                'Bedrukt voor & achter'
              ],
              default: 'Bedrukt voor & achter'
            },
            {
              title: 'Papiersoort omslag',
              type: 'option',
              options: [
                'Gelijk aan boekje',
                'Stevig 120g',
                'Extra stevig 160g'
              ],
              default: 'Extra stevig 160g'
            }
          ]
        }
      },
      default: 'Vouwen & nieten'
    }
  ],
  Rapport: [
    {
      title: 'Formaat',
      type: 'slider',
      options: ['A4', 'A5'],
      default: 'A4',
      align: 'left'
    },
    {
      title: 'Papiersoort',
      type: 'slider',
      options: ['80g', '100g', '120g'],
      default: '100g',
      align: 'right'
    },
    {
      title: 'Z/W of kleur',
      type: 'slider',
      options: ['z/w', 'kleur'],
      default: 'kleur',
      align: 'left'
    },
    {
      title: '1- of 2-zijdig',
      type: 'slider',
      options: ['1 z', '2 z'],
      default: '2 z',
      align: 'right'
    },
    {
      title: 'Aflopend printen',
      type: 'slider',
      options: ['ja', 'nee'],
      default: 'nee'
    },
    {
      title: 'Bindwijze',
      type: 'option',
      options: {
        'Ringband metaal': {
          type: 'submenu',
          submenus: [
            {
              title: 'Voorkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Bedrukt (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            },
            {
              title: 'Achterkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Blanco (zeer stevig)',
                'Bedrukt (zeer stevig)',
                'Transparant + blanco (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant + blanco (zeer stevig)'
            }
          ]
        },
        'Ringband plastic': {
          type: 'submenu',
          submenus: [
            {
              title: 'Voorkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Bedrukt (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            },
            {
              title: 'Achterkant',
              type: 'option',
              options: [
                'Transparant (plastic)',
                'Blanco (zeer stevig)',
                'Bedrukt (zeer stevig)',
                'Transparant + blanco (zeer stevig)',
                'Transparant + bedrukt (zeer stevig)'
              ],
              default: 'Transparant (plastic)'
            }
          ]
        },
        'Garenloos (lijmen)': {
          type: 'submenu',
          submenus: [
            {
              title: 'Omslag',
              type: 'option',
              options: [
                'Voorkant bedrukt (zeer stevig)',
                'Bedrukt pagina 1+2 (zeer stevig)',
                'Bedrukt voor & achter (zeer stevig)'
              ],
              default: 'Voorkant bedrukt (zeer stevig)'
            }
          ]
        }
      },
      default: 'Garenloos (lijmen)'
    }
  ]
}
